import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';
import {AppState} from '../states/app.state';


export class VersandstatusHistoryDialogSelectors {

  private static select = {
    state: (state: AppState) => state.versandstatusHistoryDialog,
    isOpen: (state: AppState) => state.versandstatusHistoryDialog.isOpen,
  };

  public static isVersandstatusHistoryDialogOpen = createSelector(
    this.select.isOpen,
    identity,
  );

  public static versandstatus = createSelector(
    this.select.state,
    state => ({
      betriebId: state.betriebId,
      belegId: state.belegId,
      belegnummer: state.belegnummer,
      belegart: state.belegart,
    }),
  );
}
